import { useEffect } from 'react';
import { useToast } from '../modules/hooks/useToast';
import * as serviceWorkerRegistration from '../utils/serviceWorkerRegistration';

/**
 * Component that handles service worker registration and update notifications
 * Uses the toast system to inform users when updates are available
 */
const ServiceWorkerUpdateHandler = () => {
  const showToast = useToast();

  useEffect(() => {
    // Only register service worker in production
    if (import.meta.env.PROD) {
      serviceWorkerRegistration.register({
        onUpdate: (registration) => {
          console.log('New service worker available');

          // Show user-friendly notification
          showToast('New version available! Refreshing...', 'info');

          // Wait 2 seconds to let user see the message, then reload
          setTimeout(() => {
            // Skip waiting and activate new service worker immediately
            if (registration.waiting) {
              registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }

            // Reload the page to use the new service worker
            window.location.reload();
          }, 2000);
        },
        onSuccess: (registration) => {
          console.log('Service worker registered successfully');
          // Silent success - no need to notify user
        },
      });
    }
  }, [showToast]);

  // This component doesn't render anything
  return null;
};

export default ServiceWorkerUpdateHandler;
